<template>
    <div class="cloud-three-video-group-container">
        <div v-for="(titleItem, titleIndex) in filterList" :key="titleIndex" :class="`cloud-card-${titleIndex}`">
            <div class="cloud-group-title">
                <CommonComponentsProductsTitleFunctionTitle :function-title="titleItem" :color-index="colorIndex" />
            </div>
            <div class="cloud-group-video">
                <CommonComponentsVideoPlayer
                    class="video"
                    :sources="[
                        {
                            src: titleItem.path,
                            type: 'video/mp4',
                        },
                    ]"
                    :poster="titleItem.poster"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import path1 from '@assets/Video/products/cloud/cloud1.mp4';
    import path2 from '@assets/Video/products/cloud/cloud2.mp4';
    import path3 from '@assets/Video/products/cloud/cloud3.mp4';
    import path1_en from '@assets/Video/products/cloud/cloud1_en.mp4';
    import path2_en from '@assets/Video/products/cloud/cloud2_en.mp4';
    import path3_en from '@assets/Video/products/cloud/cloud3_en.mp4';
    import path4_en from '@assets/Video/products/cloud/cloud4_en.mp4';
    import cloud1_Poster from '@assets/Video/products/cloud/cloud1.jpg';
    import cloud2_Poster from '@assets/Video/products/cloud/cloud2.jpg';
    import cloud3_Poster from '@assets/Video/products/cloud/cloud3.jpg';
    import cloud1_en_Poster from '@assets/Video/products/cloud/cloud1_en.jpg';
    import cloud2_en_Poster from '@assets/Video/products/cloud/cloud2_en.jpg';
    import cloud3_en_Poster from '@assets/Video/products/cloud/cloud3_en.jpg';
    import cloud4_en_Poster from '@assets/Video/products/cloud/cloud4_en.jpg';
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const colorIndex = 0;
    // addToVideoElmt('.video');
    const isCN = ifCNLocale();

    const functionTitleList: Array<FunctionTitle> = [
        {
            colorTitle: 'global_home_header_submenu_link_0_2',
            title: 'global_cloud_title_1',
            subTitle: 'global_cloud_subTitle_1',
            path: isCN ? path1 : path1_en,
            poster: isCN ? cloud1_Poster : cloud1_en_Poster,
        },
        {
            colorTitle: 'global_home_header_submenu_link_0_2',
            title: 'global_cloud_title_2',
            subTitle: 'global_cloud_subTitle_2',
            path: isCN ? path2 : path2_en,
            poster: isCN ? cloud2_Poster : cloud2_en_Poster,
        },
        {
            colorTitle: 'global_home_header_submenu_link_0_2',
            title: 'global_cloud_title_3',
            subTitle: 'global_cloud_subTitle_3',
            path: isCN ? path3 : path3_en,
            poster: isCN ? cloud3_Poster : cloud3_en_Poster,
        },
        {
            colorTitle: 'global_home_header_submenu_link_0_2',
            title: 'global_cloud_title_0',
            subTitle: 'global_cloud_subTitle_0',
            path: path4_en,
            poster: cloud4_en_Poster,
        },
    ];

    const filterList = computed(() => (isCN ? functionTitleList.slice(0, -1) : functionTitleList));
</script>

<style lang="less" scoped>
    .cloud-three-video-group-container {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        width: 100%;

        .cloud-group-title {
            margin: .convert(100px) [ @vw] 0 .convert(40px) [ @vw] .convert(80px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                margin-top: .convert(50px) [ @vw-mobile];
                margin-bottom: .convert(15px) [ @vw-mobile];
            }
        }
        .cloud-group-video {
            display: flex;
            video {
                margin: 0 auto;
                width: .convert(1200px) [ @vw];
                height: .convert(675px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    width: .convert(305px) [ @vw-mobile];
                    height: .convert(172px) [ @vw-mobile];
                }
            }
        }
    }
</style>
